import { format, subMonths } from "date-fns";
export const getLastMonthName = () => {
  const currentDate = new Date();
  const lastMonth = subMonths(currentDate, 1);

  const lastMonthName = format(lastMonth, "MMMM, yyyy");
  return lastMonthName;
};
